import React from "react";
import SeoTable from "./components/SeoTable";

function StaticSeoTable() {
  return <SeoTable entityType="static-page" />;
}

export default StaticSeoTable;
